import isNumber from '@blockcatio/tabby-library/lib/utilities/isNumber';

/**
 * Check if value is a valid float with no more than max decimal places.
 *
 * @param {String|Number} value
 * @param {Number} maxDecimals
 *
 * @return {Bool}
 */
const isValidFloat = (value, maxDecimals) => {
  if (isNumber(value)) {
    const parts = value.toString().split('.');
    if (parts.length === 2) {
      return parts[1].length <= maxDecimals;
    }
    return true;
  }
  return false;
};

export default isValidFloat;



// WEBPACK FOOTER //
// ./src/utilities/isValidFloat.js